import React from 'react';
import ModelValidator from 'lib/ModelValidator';
import merge from 'lodash/merge';

export default function addressesValidator(values) {
  const validator = new ModelValidator(values);
  const validations = {
    "billing.first_name":   ['required'],
    "billing.last_name":    ['required'],
    "billing.email":        ['required', 'email'],
    "billing.street":       ['required'],
    "billing.post_code":    ['required'],
    "billing.city":         ['required'],
    "billing.country":      ['required'],
  };
  
  if (!values.billing.sameShipping) {
    merge(validations, {
      "shipping.first_name":   ['required'],
      "shipping.last_name":    ['required'],
      "shipping.street":       ['required'],
      "shipping.post_code":    ['required'],
      "shipping.city":         ['required'],
      "shipping.country":      ['required'],
    });
  }

  return validator.getAllErrors(validations);
};
